module.exports = __webpack_public_path__ + "img/szechenyiplus.9ca46270.png";